export default __webpack_public_path__ + "static/media/boxes.d49365db.webp";